/**
 * STAGE 3 — Selectors
 * -------------------
 * Selectors read data FROM the Redux store.
 * Components use useSelector(selectTotalChips) instead of useSelector(state => state.appData.totalChips).
 *
 * Benefits:
 * - One place to rename or reshape state later
 * - Easier to test and reuse
 */
export const selectTopHeaderText = (state) => state.topHeaderText

export const selectUserData = (state) => state.userData

export const selectPermission = (state) => state.permission

export const selectLoading = (state) => state.loading

export const selectAppData = (state) => state.appData

export const selectIsAppDataLoaded = (state) => state.appData?.isLoaded

export const selectTotalChips = (state) => state.appData?.totalChips ?? 0

export const selectTotalCash = (state) => state.appData?.totalCash ?? 0

export const selectProfileImage = (state) => state.appData?.profileImage ?? ''

export const selectAppDataLoading = (state) => state.appData?.loading ?? false

export const selectDashboardData = (state) => state.dashboard?.dashboardData || {}
export const selectPaymentsData = (state) => state.dashboard?.paymentsData
export const selectDauData = (state) => state.dashboard?.dauData || []
export const selectPeakData = (state) => state.dashboard?.peakData || []

export const selectGradesPages = (state) => state.grades?.pages || {}
export const selectGradesIsLoaded = (state) => state.grades?.isLoaded || false
export const selectGradesPagerecord = (state) => state.grades?.pagerecord || {
  totalItems: 0,
  totalPages: 1,
  pageNumber: 1,
  pageSize: 5
}

export const selectBankWithdrawPages = (state) => state.bankWithdraw?.pages || {}
export const selectBankWithdrawIsLoaded = (state) => state.bankWithdraw?.isLoaded || false
export const selectBankWithdrawPagerecord = (state) => state.bankWithdraw?.pagerecord || {
  totalItems: 0,
  pageNumber: 1,
  pageSize: 25,
  totalPages: 1
}

export const selectVideosPages = (state) => state.videos?.pages || {}
export const selectVideosIsLoaded = (state) => state.videos?.isLoaded || false
export const selectVideosPagerecord = (state) => state.videos?.pagerecord || {
  totalItems: 0,
  pageNumber: 1,
  pageSize: 12,
  totalPages: 1
}

export const selectUsersPages = (state) => state.users?.pages || {}
export const selectUsersIsLoaded = (state) => state.users?.isLoaded || false
export const selectUsersPagerecord = (state) => state.users?.pagerecord || {
  totalItems: 0,
  pageNumber: 1,
  pageSize: 25,
  totalPages: 1
}



